import { getConfigProperty } from '../../core/EnvironmentConfig/EnvironmentConfig';
import * as DevStore from './store.dev';
import * as ProdStore from './store.prod';

const storeConfig = getConfigProperty("appEnvironment") !== "production" ? DevStore : ProdStore;

export const persistLogout = () => () => {
  const { persistor } = storeConfig;

  if (typeof persistor.flush === 'function') {
    const result = persistor.flush();
    
    if (result instanceof Promise) {
      result.then(() => persistor.purge());
    } else {
      persistor.purge();
    }
  } else {
    persistor.purge();
  }
};

export const { store, persistor } = storeConfig;
